<template>
  <div class="config-creation">
    <v-card class="mt-6 mb-6">
      <v-card-title>Configuration d'un Nouvel Utm </v-card-title>
      <v-row class="mr-6 ml-6">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="utm.source"
            label="source"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="utm.acqui_platform_id"
            :items="platforms"
            item-text="name"
            item-value="id"
            label="Plateformes"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="utm.campaign"
            label="Campaign"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-12 pb-6">
        <v-btn class="ml-6 mr-6 secondary" @click="saveUtm">Enregistrer</v-btn>
        <v-btn class="ml-6 mr-6 primary" @click="cancelUtm">Annuler</v-btn>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import useAxios from "@/hooks/useAxios";
export default {
  name: "UtmCreation",
  components: {},
  data() {
    return {
      utm: {},
    };
  },
  setup() {
    const { axiosGet, axiosPost, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
    };
  },
  async created() {},
  methods: {
    cancelUtm() {
      (this.utm = {
        id: "",
        source: "",
        campaign: "",
        acqui_platform_id: "",
      }),
        this.$emit("close-dialog");
    },
    async saveUtm() {
      if (this.utm.campaign == "") {
        this.utm.campaign = "NA";
      }
      const params = {
        source: this.utm.source,
        acqui_platform_id: this.utm.acqui_platform_id,
        campaign: this.utm.campaign,
      };
      try {
        await this.axiosPost(`/acquisition/utm/`, params);
      } catch (error) {
        console.error("Error saving UTM:", error);
        alert(
          "Erreur lors de la création de l'UTM, Vérifier l'intégrité des données (doublons). Si les données sont intègres utilisez l'outil de report d'erreur"
        );
        this.cancelUtm();
      }
      this.$emit("saved");
    },
  },
  computed: {
    platforms() {
      return this.$store.getters["acquisition/getPlatforms"];
    },
  },
};
</script>
<style scoped>
.config-creation {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
